<template>
  <div class="performance-pie-chart position-relative">
    <doughnut-chart
      :chart-data="datacollection"
      :options="options"
    ></doughnut-chart>

    <!-- AVERAGE SCORE DISPLAY -->
    <div class="average-score-display">
      <div
        class="score font-weight-bold color_text text-center"
        :class="{ 'blur-text': !see_score }"
      >
        {{ getAverageScore() }}%
      </div>
      <div class="score-meta text-uppercase color_grey_dark text-center">
        {{ chart_title }}
      </div>
    </div>
  </div>
</template>

<script>
import DoughnutChart from "@/scripts/components/DoughnutChart";

export default {
  name: "PerformanceChart",

  components: {
    DoughnutChart,
  },

  props: {
    average_score: Number,
    chart_title: {
      type: String,
      default: "Avg. Score",
    },
    switch_color: {
      type: Boolean,
      default: false,
    },

    see_score: {
      type: [Number, Boolean, String],
      default: false,
    },
  },

  watch: {
    average_score: "fillData",
  },

  data() {
    return {
      score_left: "",
      base_color: "#00E29F",
      base_hover_color: "#01a775",
      datacollection: {},
      options: {},
      emptyData: [
        {
          label: "Average Score",
          data: [0, 100],
          backgroundColor: ["#FE747D", "#d7ebee"],
          hoverBackgroundColor: "#c3e6ec",
          borderWidth: 0,
        },
      ],
    };
  },

  mounted() {
    this.fillData();
  },

  methods: {
    getAverageScore() {
      if (isNaN(this.average_score)) return 0;
      else return this.average_score;
    },

    getScoreLeft() {
      this.score_left = 100 - this.average_score;
    },

    switchColor() {
      this.base_color = "#FAA017";
    },

    processAverageColor() {
      if (this.average_score >= 75) return "#00E29F";
      else if (this.average_score >= 45 && this.average_score <= 74)
        return "#FAA017";
      else if (this.average_score <= 44) return "#FE747D";
      else return "#ccfced";
    },

    fillData() {
      this.getScoreLeft();

      this.switch_color ? this.switchColor() : "";

      this.datacollection = {
        labels: ["Average Score", "Score Lost"],
        datasets: this.see_score
          ? [
              {
                label: "Average Score",
                data: [this.average_score, this.score_left],
                backgroundColor: [this.processAverageColor(), "#d7ebee"],
                hoverBackgroundColor: "#c3e6ec",
                borderWidth: 0,
              },
            ]
          : this.emptyData,
      };

      this.options = {
        cutoutPercentage: 75,
        aspectRatio: 1,
        legend: {
          display: false,
        },
      };
    },
  },
};
</script>

<style lang="scss">
.performance-pie-chart {
  color: #d7ebee;
  @include equal_min_edge(250);

  @include breakpoint_max(xl) {
    @include equal_min_edge(220);
  }

  @include breakpoint_max(lg) {
    @include equal_min_edge(170);
  }

  @include breakpoint_max(md) {
    @include equal_min_edge(200);
    margin-left: auto;
    margin-right: auto;
  }

  .average-score-display {
    @include transform_center;
  }

  .score {
    font-size: 28px;
    line-height: 38px;
    margin-bottom: 4px;

    @include breakpoint_max(lg) {
      font-size: 22px;
    }
  }

  .score-meta {
    font-size: 12px;
    line-height: 16px;

    @include breakpoint_max(lg) {
      font-size: 10px;
    }
  }

  .blur-text {
    filter: blur(10px);
  }
}
</style>
